const HIDE_MAINTENANCE_PAGES_TOGGLE = 'ft_hide_maintenance_pages';

export const MAINTENANCE_BANNER_ENABLED = false;
// 13:00 UTC == 14:00 in Lisbon (WEST) == 15:00 in Berlin (CEST).
export const MAINTENANCE_START = new Date('2026-09-10T13:00:00Z');

// Formats the start of the window in the user's own timezone, including the zone name.
export const formatMaintenanceStart = locale =>
    new Intl.DateTimeFormat(locale, {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZoneName: 'short',
    }).format(MAINTENANCE_START);

const isHideMaintenancePagesEnabled = () => {
    try {
        return window.localStorage.getItem(HIDE_MAINTENANCE_PAGES_TOGGLE) === 'true';
    } catch {
        return false;
    }
};

// The banner warns in advance, and stays up until it is switched off in another commit.
export const isMaintenanceAnnounced = () => MAINTENANCE_BANNER_ENABLED;

// The page is only replaced once the window has actually started.
// Setting the 'ft_hide_maintenance_pages' local storage key to 'true' bypasses the gate without a deployment.
export const isUnderMaintenance = (now = new Date()) =>
    !isHideMaintenancePagesEnabled() && isMaintenanceAnnounced() && now >= MAINTENANCE_START;
